<style lang="scss">
.page-customer {
  .el-tabs {
    &__header {
      margin-bottom: 0;
      background: #fff;
      padding: 10px 20px 0;
    }
  }
  .customer-block {
    // .hd {
    @include border-shadow();
    border-radius: 6px;
    padding: 20px;
    // }
  }
  .name-mobile-input {
    width: 300px;
    .el-input {
      width: 110px;
    }
  }
  .search-fields-row {
    > div {
      margin-right: 10px;
    }
  }
  .avatar-wrap {
    display: flex;
    .avatar-icon {
      margin-right: 10px;
      img {
        width: 30px;
        display: block;
      }
    }
    .avatar-info {
      .name {
      }
      .mobile {
      }
    }
  }
  .tag-lists {
    display: flex;
    flex-wrap: wrap;
    .tag-item {
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }
  .label-tooltip {
    cursor: pointer;
  }
}
.label-content {
  display: flex;
  width: 200px;
  .tag-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
.sp-finder-hd {
  position: relative;
  .button {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.search-field-label{
  min-width: 80px;
}
.search-field:last-child {
  width: 40% !important;
}
.search-field:nth-last-child(2) {
  width: 40% !important;
}
</style>
<template>
  <div class="page-customer">
    <el-tabs v-model="tabActive">
      <el-tab-pane
label="客户属性筛选"
name="tab1"
>
        <SpFinder
          id="1"
          ref="finder"
          title=""
          :url="{
            data: dataUrl
          }"
          :split-count="3"
          :setting="{
            search: [
              {
                type: 'select',
                key: 'sex',
                name: '性别',
                size: 'medium',
                placeholder: '请选择性别',
                options: [
                  { value: '1', label: '男' },
                  { value: '2', label: '女' },
                  { value: '0', label: '未知' }
                ]
              },
              {
                type: 'select',
                key: 'is_member',
                name: '是否是会员',
                size: 'medium',
                placeholder: '请选择',
                options: [
                  { value: 1, label: '是' },
                  { value: 0, label: '否' }
                ]
              }
            ]
          }"
          :search="[
            { key: 'channel', name: '渠道名称', slot: 'channel' },
            { key: 'label', name: '客户标签', slot: 'label' },
            { key: 'name', name: '', slot: 'name' },
            { key: 'guide', name: '', slot: 'guide' }
          ]"
          row-key="id"
          :columns="columns"
          :actions="actions"
          :show-tool-bar="false"
          :hooks="{
            beforeSearch: beforeSearch
          }"
          :reserve-selection="true"
          @reset="onFinderReset"
          @selection="selectChange"
        >
          <template v-slot:channel>
            <el-select
v-model="channel"
placeholder="请选择渠道"
>
              <el-option
                v-for="item in channelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-slot:name>
            <el-input
v-model="keyword"
class="name-mobile-input"
placeholder="请输入内容"
>
              <el-select
slot="prepend"
v-model="nameOrMobile"
placeholder="请选择"
size="small"
>
                <el-option
label="客户姓名"
value="1"
/>
                <el-option
label="客户手机号"
value="2"
/>
              </el-select>
            </el-input>
          </template>
          <template v-slot:guide>
            <el-button @click="handleShowGuidePicker">
              <!-- 添加导购以筛选 -->
              添加导购以筛选{{
                callData.userList.length > 0 ? `（${callData.userList.length}个导购）` : ''
              }}
            </el-button>
          </template>

          <template v-slot:label>
            <div
class="el-select"
@click="selectBabelFilter"
>
              <div class="el-input el-input--suffix">
                <input
                  v-model="searchTags"
                  type="text"
                  readonly
                  placeholder="请选择标签"
                  class="el-input__inner"
                >
                <span class="el-input__suffix">
                  <span class="el-input__suffix-inner">
                    <i class="el-select__caret el-input__icon el-icon-arrow-up" />
                  </span>
                </span>
              </div>
            </div>
          </template>
        </SpFinder>
        <!-- <el-button class="button" @click="this.markVisible = true">按购买记录打标</el-button> -->
      </el-tab-pane>
      <!-- <el-tab-pane
        label="所在群聊筛选"
        name="tab2"
      >
        <SpFinder
          id="1"
          ref="finder"
          title=""
          no-selection
          :url="{
            data: dataUrl
          }"
          :search="[
            { key: 'name', name: '', slot: 'name' },
            { key: 'guide', name: '', slot: 'guide' }
          ]"
          :columns="columnsGroup"
          :actions="actions"
          :show-tool-bar="false"
          :hooks="{
            beforeSearch: beforeSearchGroup
          }"
          @reset="onFinderResetGroup"
        >
          <template v-slot:name>
            <el-input
              v-model="keyword"
              class="name-mobile-input"
              placeholder="请输入内容"
            >
              <el-select
                slot="prepend"
                v-model="nameOrMobile"
                placeholder="请选择"
              >
                <el-option
                  label="客户姓名"
                  value="1"
                />
                <el-option
                  label="客户手机号"
                  value="2"
                />
              </el-select>
            </el-input>
          </template>
          <template v-slot:guide>
            <el-button @click="handleSelectGuide">
              添加群聊以筛选{{ groupData.length > 0 ? `（${groupData.length}个群聊）` : '' }}
            </el-button>
          </template>
        </SpFinder>
      </el-tab-pane> -->
    </el-tabs>
    <SpGuideBox
v-model="showGuidePicker"
:call-data="callData"
@getUserList="onChangeGuide"
/>

    <MarkDialog
      :mark-visible="markVisible"
      :mark-data="markData"
      @markVisibleChange="markVisibleChange"
    />
  </div>
</template>

<script>
import MarkDialog from './comps/markDialog.vue'
export default {
  name: '',
  components: {
    MarkDialog
  },
  data () {
    return {
      searchTags: '',
      selectBabelIds: [],
      exportDialogVisible: false,
      tab_type: '',
      tabActive: 'tab1',
      dataUrl: `${process.env.VUE_APP_BASE_API}/members/member`,
      columns: [
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          name: '头像/姓名/手机号',
          search: false,
          show: true,
          width: 200,
          render: (h, { row }) => {
            return (
              <div
                class='avatar-wrap'
                onClick={() => {
                  this.handleJump(row)
                }}
              >
                <div class='avatar-icon'>
                  <img src={row.avatar} />
                </div>
                <div class='avatar-info'>
                  <div class='name'>{row.nickname}</div>
                  <div class='mobile'>{row.mobile}</div>
                </div>
              </div>
            )
          }
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          name: '性别',
          search: false,
          show: true,
          width: 80,
          render: (h, { row }) => {
            return row.sex == 0 ? '未知' : row.sex == 1 ? '男' : '女'
          }
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          name: '客户身份',
          search: false,
          show: true,
          width: 80,
          render: (h, { row }) => {
            return row.register_time ? '会员' : ''
          }
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          // key: 'salesperson_name',
          name: '专属导购',
          search: false,
          show: true,
          width: 150,
          // render:(h,{row})=>{
          //   return row.sex == 0 ? '其他': row.sex == 1 ?'男':'女'
          // }
          render: (h, { row }) => {
            return (
              <div>
                <div>{row.bind_salesperson_name}</div>
                <div>{row.bind_employee_number}</div>
              </div>
            )
          }
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          name: '标签',
          search: false,
          show: true,
          minWidth: 220,
          render: (h, { row }) => {
            let list = row.tags.slice(0, 5)
            let overList = row.tags.slice(5, row.tags.length)
            return (
              <div class='tag-lists'>
                {list &&
                  list.map((v) => {
                    return (
                      <el-tag effect='plain' key={v.id} class='tag-item' type='info' size='small'>
                        {v.title}
                      </el-tag>
                    )
                  })}
                {overList && overList.length > 0 && (
                  <el-tooltip
                    class='label-tooltip'
                    popper-class='label-content'
                    effect='light'
                    placement='top'
                  >
                    <div slot='content'>
                      {overList.map((v) => {
                        return (
                          <el-tag effect='plain' key={v.id} class='tag-item' size='small'>
                            {v.title}
                          </el-tag>
                        )
                      })}
                    </div>
                    <el-tag effect='plain' type='info' size='small'>
                      更多
                    </el-tag>
                  </el-tooltip>
                )}
              </div>
            )
          }
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          key: 'created_at',
          name: '添加时间',
          search: false,
          show: true,
          width: 160
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          key: 'channel_name',
          name: '添加渠道',
          search: false,
          show: true,
          width: 100
        }
      ],
      actions: [
        {
          name: '批量打标签',
          key: 'create',
          slot: 'header',
          type: 'button',
          buttonType: 'primary',
          action: {
            handler: (row) => {
              let selection = this.$refs.finder.$refs.finderTable.selection
              if (selection.length < 1) {
                this.$message.error('请至少勾选一个客户')
              } else {
                this.$batchLabel(
                  {
                    tagsList: this.tags,
                    selectionBabel: true
                  },
                  (val) => {
                    this.batchTagging(val)
                  }
                )
              }
            }
          }
        },
        {
          name: '导出',
          key: 'create',
          slot: 'header',
          type: 'button',
          buttonType: 'primary',
          action: {
            handler: (row) => {
              this.$exportList({
                filesType: 13,
                showChannel: true,
                tabType: 'tab_type'
              })
            }
          }
        },
        {
          name: '按购买记录打标',
          key: 'create',
          slot: 'header',
          type: 'button',
          buttonType: 'primary',
          action: {
            handler: (row) => {
              this.markVisible = true
            }
          }
        },
        {
          key: 'detail',
          name: '详情',
          type: 'button',
          action: {
            path: '/customer/index/${id}',
            type: 'link'
          }
        }
      ],
      columnsGroup: [
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          key: 'account',
          name: '头像/姓名/手机号',
          search: false,
          show: true,
          width: 200,
          render: (h, { row }) => {
            return (
              <div
                class='avatar-wrap'
                onClick={() => {
                  this.handleJump(row)
                }}
              >
                <div class='avatar-icon'>
                  <img src={row.avatar} />
                </div>
                <div class='avatar-info'>
                  <div class='name'>{row.nickname}</div>
                  <div class='mobile'>{row.mobile}</div>
                </div>
              </div>
            )
          }
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          key: 'salesperson_name',
          name: '专属导购',
          search: false,
          show: true,
          width: 150
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          key: 'channel',
          name: '所属群聊',
          search: false,
          show: true,
          width: 250
        },
        {
          componentType: 'string',
          displayInForm: true,
          field_type: '1',
          filter: false,
          index: 1,
          key: 'created_at',
          name: '添加时间',
          search: false,
          show: true,
          width: 150
        }
      ],
      options: [],
      channelValue: '',
      sexValue: '',
      nameOrMobile: '1',
      tags: [],
      keyword: '',
      callData: {
        storeList: [],
        userList: []
      },
      channelOptions: [],
      channel: '',
      groupData: [],
      showGuidePicker: false,
      markVisible: false,
      markData: []
    }
  },
  created () {
    this.getChannelList()
  },
  mounted () {},
  methods: {
    // 批量绑定标签
    async batchTagging (tagsList, readonlyTag) {
      let tags_id = tagsList.map((v) => v.id)
      if (readonlyTag) {
        this.tags = tagsList
        this.searchTags = '已选择' + tagsList.length + '个标签'
      } else {
        const data = await this.$api.customer
          .batchTagging({
            tags_id: tags_id,
            unionid: this.$refs.finder.$refs.finderTable.selection.map((v) => v.unionid)
          })
          .catch(() => {
            this.$refs.finder.$refs.finderTable.selection = []
            this.$refs.finder.refresh()
          })
        if (data && data.status) {
          // this.$refs.finder.$refs.finderTable.selection = []
          this.$refs.finder.refresh()
          this.$message.success('打标签成功')
        }
      }
    },
    // 渠道列表
    async getChannelList () {
      const { list } = await this.$api.salesperson.getChannelList()
      this.channelOptions = list.map((item) => {
        return {
          label: item.channel_name,
          value: item.dynamic_code_id
        }
      })
      this.channel = ''
      console.log(this.channelOptions)
    },
    async handleSelectGuide () {
      const { data } = await this.$groupChatPicker({
        data: this.groupData
      })
      console.log('handleSelectGuide:', data)
      this.groupData = data
    },
    handleClickGuidePicker () {
      this.showGuidePicker = true
    },
    onChangeGuide (data) {
      console.log('onChangeGuide:', data)
      const { storeList, userList } = data
      this.callData = {
        storeList: storeList,
        userList: userList
      }
    },
    handleShowGuidePicker () {
      this.showGuidePicker = true
    },
    // 搜索重置
    onFinderReset () {
      this.tags = []
      this.searchTags = ''
      this.keyword = ''
      this.channel = ''
      this.callData = {
        storeList: [],
        userList: []
      }
    },
    beforeSearch (params) {
      console.log('beforeSearch:', params)
      if (this.nameOrMobile == '1' && this.keyword) {
        params['nickname'] = this.keyword
      } else if (this.nameOrMobile == '2' && this.keyword) {
        params['mobile'] = this.keyword
      }
      if (this.tags && this.tags.length > 0) {
        params['tags_id'] = this.tags.map((v) => v.id)
      }
      const channelName = this.channelOptions.find((item) => item.value == this.channel)
      // console.log('channelName:', channelName)
      if (channelName) {
        params['channel_name'] = channelName.label
      }
      if (this.callData && this.callData.userList) {
        params['salesperson_id'] = this.callData.userList
          .map((item) => item.salesperson_id)
          .join(',')
      }

      return params
    },
    onFinderResetGroup () {
      this.groupData = []
      this.keyword = ''
      this.callData = {
        storeList: [],
        userList: []
      }
    },
    beforeSearchGroup (params) {
      console.log('beforeSearchGroup:', params)
      if (this.nameOrMobile == '1' && this.keyword) {
        params['nickname'] = this.keyword
      } else if (this.nameOrMobile == '2' && this.keyword) {
        params['mobile'] = this.keyword
      }
      if (this.groupData.length > 0) {
        params['chat_id'] = this.groupData.map((item) => item.chat_id).join(',')
      }
      return params
    },

    selectChange (data) {
      console.log(data)
    },
    selectBabelFilter () {
      this.$batchLabel(
        {
          readonly: true,
          tagsList: this.tags,
          selectionBabel: true,
          showSelectedTags: true
        },
        (val) => {
          this.batchTagging(val, true)
        }
      )
    },
    handleJump (value) {
      this.$router.push({
        path: `/customer/index/${value.id}`
      })
    },
    async markVisibleChange (value) {
      if (value[0] === false) {
        this.markVisible = false
      }
      if (value[1]) {
        const data = await this.$api.customer.asyn_batch_tagging(value[1])
        if (data && data.status) {
          this.markData = []
          this.$message.success('按购买记录打标成功')
        } else {
          this.markVisible = true
        }
      }
    }
    
  }
}
</script>
